import { Expose, Type } from "class-transformer";
import { ValidateNested } from "class-validator";
import { InlineInfoEntity } from "../../entity";

export class MutateInlineInfoDTO {
  @Expose()
  @ValidateNested()
  @Type(() => InlineInfoEntity)
  inlineInfo!: InlineInfoEntity;
}
